import AppBar from "@material-ui/core/AppBar";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import Typography from "@material-ui/core/Typography";
import { Toolbar } from "@material-ui/core";
import Link from "@material-ui/core/Link";

export interface HeaderProps extends WithStyles<typeof styles> {}

const styles = createStyles({
  footer: {
    position: "fixed",
    bottom: 0,
    top: "auto",
    width: "100%"
  },
  grow: {
    flexGrow: 1
  },
  footerBar: {
    minHeight: "48px",
    padding: "0 12px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#eeeeee"
  }
});

const Footer = ({ classes }: HeaderProps) => (
  <footer className={classes.footer}>
    <div className={classes.footerBar}>
      <Typography variant="caption" color="inherit" className={classes.grow}>
        Built with{" "}
        <Link
          color={"secondary"}
          href="https://github.com/facebook/create-react-app"
          target="_blank"
        >
          Create-React-App
        </Link>{" "}
        by{" "}
        <Link href={"https://www.dabolivar.com"} color={"secondary"} target="_blank">
          Daniel Bolívar
        </Link>
      </Typography>
    </div>
  </footer>
);

export default withStyles(styles)(Footer);
